import { TSelectOption } from '@interfaces/components/componentTypes';
import { TSelectOptionType } from '@components/common/Select/Select.types';

const HOURS = 24;
const MINUTES = 60;
const DOUBLE_DIGIT_LIMIT = 10;

export const hoursOptions: Array<TSelectOptionType<number>> = Array.from({ length: HOURS }, (_, index) => ({
	value: index,
	label: index < DOUBLE_DIGIT_LIMIT ? `0${index.toString()}` : index.toString(),
}));

export const minutesOptions: Array<TSelectOptionType<number>> = Array.from({ length: MINUTES + 1 }, (_, index) => ({
	value: index,
	label: index < DOUBLE_DIGIT_LIMIT ? `0${index.toString()}` : index.toString(),
}));

export const nonNullishMinutesOptions = minutesOptions.filter((option) => Number(option?.value) >= 1);

export const hourlyTimeOptions: TSelectOption<string>[] = [
	...Array.from({ length: 24 }, (_, index) => {
		const valueHour = index;
		const valueHourFormatted = valueHour < DOUBLE_DIGIT_LIMIT ? `0${valueHour}` : `${valueHour}`;

		return {
			label: `${valueHourFormatted}:00`,
			value: `${valueHourFormatted}:00`,
		};
	}),
	{
		label: '24:00',
		value: '23:59',
	},
];
